module.exports = __webpack_public_path__ + "static/media/Mentorship-7.9b63d098.jpg";